
export default {
  data: () => ({
    //AccessedUserRoles: [],
  }),
  
  methods: {
    showError(errorMsg) {
      //duplicate handler
      this.$snotify.error(errorMsg);
    },
    showWarning(msg) {
      this.$snotify.warning(msg);
    },
    showSuccess(msg) {
      this.$snotify.success(msg);
    },
    // async GetUserRoles() {
    //   var queryString = `query userDetails($id:String!){
    //                             userDetails(id: $id){
    //                           group{
    //                             id
    //                             groupName
    //                             usergrouproles{
    //                               roles{
    //                                 roleName  
    //                               }
    //                             }
    //                           }
    //                         }
    //                         }`;

    //   await axios
    //     .post('/graphql', {
    //       query: queryString,
    //       variables: {
    //         id: this._data.$$state.user.id,
    //       },
    //     })
    //     .then((response) => {
    //       this.roles = [];
    //       if (response.data.data.userDetails != null) {
    //         let user = response.data.data.userDetails;
    //         if (user.group && user.group.length > 0) {
    //           user.group.forEach((element) => {
    //             let roles = element.usergrouproles;
    //             if (roles.length > 0) {
    //               roles.forEach((el) => {
    //                 let role = el.roles;
    //                 this.AccessedUserRoles.push(role.roleName);
    //               });
    //             }
    //           });
    //         }
    //       }
    //     })
    //     .catch(() => {
    //       this.showError('Error occurred while getting permissions');
    //     });
    //   return this.AccessedUserRoles;
    // },
    // CanManageEmployeesAppointments() {
    //   return this.AccessedUserRoles.includes(
    //     "Can manage emplyee's appointments"
    //   );
    // },
    // CanManageCompanySettings() {
    //   return this.AccessedUserRoles.includes('Can manage company settings');
    // },
    // CanManageServices() {
    //   return this.AccessedUserRoles.includes('Can manage services');
    // },
  },
};
